/* Compare table. Rows are built from the union of spec keys actually
   present, so a field nobody has filled never becomes an empty row.
   Missing values show an em dash rather than a guess.

   "Best suited for" leads, and renders as chips rather than a comma list -
   it is the row people scan first when choosing between models. */
(function () {
  var KEYS = ['Best suited for','Coverage','Bottle','Oil use','Power','Voltage','Noise','Material','Installation','Dimensions','Weight'];

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
    });
  }

  function cell(key, val) {
    if (!val) return '\u2014';
    if (key === 'Best suited for') {
      return '<span class="cro-cmpt__for">' + val.split(',').map(function (p) {
        return '<span>' + esc(p.trim()) + '</span>';
      }).join('') + '</span>';
    }
    return esc(val);
  }

  function draw() {
    var host = document.querySelector('[data-cmp-table]');
    if (!host) return;
    var d = window.croCompareData || {};
    var list = window.croCompare.read().filter(function (h) { return d[h]; });

    if (list.length < 2) {
      host.innerHTML = '<p class="cro-cmpt__empty">Pick at least two diffusers to compare. ' +
        '<a href="/collections/scent-diffusers">Browse diffusers</a></p>';
      return;
    }

    var rows = KEYS.filter(function (k) {
      return list.some(function (h) { return d[h].specs[k]; });
    });

    var html = '<table class="cro-cmpt"><thead><tr><th></th>';
    list.forEach(function (h) {
      var p = d[h];
      html += '<th><a href="' + p.url + '">' +
        (p.img ? '<img src="' + p.img + '" alt="" loading="lazy">' : '') +
        '<span class="cro-cmpt__name">' + esc(p.title) + '</span></a>' +
        '<span class="cro-cmpt__price">' + esc(p.price) + '</span>' +
        '<button type="button" class="cro-cmpt__rm" data-compare="' + esc(h) + '">Remove</button></th>';
    });
    html += '</tr></thead><tbody>';

    rows.forEach(function (k) {
      html += '<tr><th scope="row">' + esc(k) + '</th>';
      list.forEach(function (h) {
        html += '<td>' + cell(k, d[h].specs[k]) + '</td>';
      });
      html += '</tr>';
    });

    html += '</tbody></table>';
    host.innerHTML = html;
  }

  document.addEventListener('compare:changed', draw);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', draw);
  } else { draw(); }
})();
